export interface loginFields {
  email?: string;
  password: string;
  login_field: string;
  login_type: string | null;
  dial_code?: string;
  mobile_number?: string;
  country_code?: string;
  account_type: string | null;
}

export interface ForgetPassword {
  email?: string;
  login_field: string;
  dial_code?: string;
  mobile_number?: string;
  country_code?: string;
  otp?: string;
}
export interface ChangePasswordData {
  current_password: string;
  confirm_password: string;
  password: string;
}

export interface VerifyOTP {
  email?: string;
  login_field: string;
  dial_code?: string;
  mobile_number?: string;
  country_code?: string;
  otp: string;
}

export interface ResetPassword {
  confirm_password?: string;
  password: string;
}
export interface Addon {
  id: number;
  type: AccountType;
  base_price: number;
  disc_price: number;
  currency_code: string;
  already_purchased: boolean;
  prorated_price: number;
}
export type AccountType = "WANT_TO_GROW" | "WANT_TO_SELL" | "INVESTMENT";

export const NEW_ACCOUNT_TYPE: Record<AccountType, string> = {
  WANT_TO_GROW: "global connect",
  WANT_TO_SELL: "business exchange",
  INVESTMENT: "capital bridge",
};

export interface Transaction {
  plan_name: string;
  user_group: string;
  feature_types: string[];
  trans_amount: number;
  trx_status: string;
  date: string;
  payment_method: string;
  created_at: string;
  trx_id: string;
  currency_code: string;
}
export interface SubscriptionFlags {
  has_active_subscription: boolean;
  has_subscription_expired: boolean;
}

export interface MySubscription {
  id: number;
  created_at: string;
  start_date: string;
  end_date: string;
  status: string;
  type: string;
  features: string[];
  duration: string;
  plan_name: string;
  trans_id: string;
  auto_renew?: boolean;
  card_brand?: string | null;
  card_last_four?: string | null;
  is_free?: number;
  has_upcoming?: boolean;
  upcoming_plan_name?: string;
  upcoming_start_date?: string;
  upcoming_id?: number;

}

export interface ActiveProfilesInterface {
  has_investment: number;
  has_investor: number;
  has_want_to_grow: number;
  has_want_to_sell: number;
}
